export default __webpack_public_path__ + "static/media/commercial.da98704b.png";